export default __webpack_public_path__ + "static/media/gama-bh.10219d67.webp";